export const STATUS_COLORS = {
  DEFAULT: { bgColor: "light-grey", textColor: "black" },
  Client: [
    { status: "Roboczy", bgColor: "light-green", textColor: "black" },
    { status: "Wysłany", bgColor: "light-grey", textColor: "black" },
    { status: "Popraw", bgColor: "red", textColor: "white" },
    { status: "Weryfikacja opłaty", bgColor: "light-grey", textColor: "black" },
    { status: "Opłać", bgColor: "orange", textColor: "black" },
    {
      status: "Oczekiwanie na anulowanie",
      bgColor: "light-violet",
      textColor: "black",
    },
    { status: "Anulowany", bgColor: "violet", textColor: "white" },
    { status: "Do opłaty i podpisu", bgColor: "orange", textColor: "black" },
    {
      status: "Weryfikacja podpisu",
      bgColor: "light-grey",
      textColor: "black",
    },
    { status: "Do opłacenia", bgColor: "orange", textColor: "black" },
    { status: "Podpisz", bgColor: "orange", textColor: "black" },
    { status: "W akceptacji", bgColor: "light-grey", textColor: "black" },
    { status: "Oczekuje na wydruk", bgColor: "light-grey", textColor: "black" },
    { status: "Odbierz", bgColor: "green2", textColor: "black" },
    {
      status: "Oczekuje na wysyłkę",
      bgColor: "light-grey",
      textColor: "black",
    },
    { status: "Wysłano", bgColor: "green2", textColor: "black" },
    { status: "Wystawione", bgColor: "green2", textColor: "black" },
    { status: "Wydane", bgColor: "violet", textColor: "white" },
    { status: "Wycofane", bgColor: "violet", textColor: "white" },
  ],
  Operator: [
    { status: "Roboczy", bgColor: "light-green", textColor: "black" },
    { status: "Nowy", bgColor: "green", textColor: "black" },
    { status: "Weryfikacja", bgColor: "blue", textColor: "black" },
    { status: "Do poprawy", bgColor: "light-grey", textColor: "black" },
    { status: "Weryfikacja opłaty", bgColor: "orange", textColor: "black" },
    { status: "Opłata za usługę", bgColor: "light-grey", textColor: "black" },
    { status: "Do anulowania", bgColor: "light-violet", textColor: "black" },
    { status: "Anulowany", bgColor: "violet", textColor: "white" },
    {
      status: "Do opłaty i podpisu",
      bgColor: "light-grey",
      textColor: "black",
    },
    { status: "Weryfikacja podpisu", bgColor: "orange", textColor: "black" },
    { status: "Do opłacenia", bgColor: "light-grey", textColor: "black" },
    { status: "Do podpisu", bgColor: "light-grey", textColor: "black" },
    { status: "Do wydania", bgColor: "yellow", textColor: "black" },
    { status: "Do wydruku", bgColor: "yellow", textColor: "black" },
    { status: "Do odbioru", bgColor: "light-grey", textColor: "black" },
    { status: "Do wysyłki", bgColor: "yellow", textColor: "black" },
    { status: "Wysłano", bgColor: "green2", textColor: "black" },
    { status: "Wystawione", bgColor: "green2", textColor: "black" },
    { status: "Wydane", bgColor: "violet", textColor: "white" },
    { status: "Wycofane", bgColor: "violet", textColor: "white" },
  ],
};

export const getStatusColor = (statusText, colorMode = "Client") => {
  if (!statusText) {
    return STATUS_COLORS.DEFAULT;
  }

  const statusLower = statusText.toLowerCase();
  const colors = STATUS_COLORS[colorMode] || STATUS_COLORS.Client;

  const found = colors.find(
    (item) => item.status.toLowerCase() === statusLower
  );

  return found || STATUS_COLORS.DEFAULT;
};

export const ALL_STATUSES = [
  "nowy",
  "roboczy",
  "wysłano",
  "weryfikacja",
  "do poprawy",
  "weryfikacja opłaty",
  "opłata za usługę",
  "do opłacenia",
  "do anulowania",
  "anulowany",
  "do podpisu",
  "do opłaty i podpisu",
  "weryfikacja podpisu",
  "do wydania",
  "do wydruku",
  "do odbioru",
  "do wysyłki",
  "wystawione",
  "wycofane",
];

export const STATUS_GROUPS = {
  PAYMENT: ["do opłacenia", "do opłaty i podpisu", "opłata za usługę"],
  SHIPPING: ["do wydruku", "do wysyłki", "wysłano"],
};
